const $inject = ['$filter', 'moment', 'ENUMS', 'dateTimeService'];

const lbTripOptionsHotelFormItemCtrl = function ($filter, moment, ENUMS, dateTimeService) {
  let vm = this;

  const dateTimeFormat = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_TIME_LONG);

  vm.flightDateTimeFormat = dateTimeFormat;
};

lbTripOptionsHotelFormItemCtrl.$inject = $inject;

export default lbTripOptionsHotelFormItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelFormItemCtrl.js